import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const introConfig: PageConfig[] = [
  {
    name: "overview1",
    title: "Whānau Initiatives Fund",
    elements: [
      {
        type: "html",
        html: `
<p>
  The Whānau Initiatives Fund (the Fund) has been established by Te Rūnanga a
  Rangitāne o Wairau Trust to support the development and delivery of
  initiatives led by Rangitāne whānau. 
</p>
<p>
  The Fund empowers and supports Rangitāne whānau to take leadership in kaupapa
  that revitalise culture, te reo Māori, tikanga, mātauranga, identity, and
  wellbeing. Its purpose is to tautoko whānau-led initiatives that contribute to
  the collective wellbeing, cultural strength, and future prosperity of
  Rangitāne ie By Whānau for Whānau.
</p>
<p>
  The Fund supports grassroots, whānau-led initiatives that are
  intergenerational, values based, and that enhance whanaungatanga, mātauranga,
  and tino rangatiratanga. Initiatives must align with the strategic priorities
  of Rangitāne o Wairau. See link to Rangitāne strategies
  <a target="_blank" href="https://rangitane.org.nz/rangitane/our-strategy">
    HERE
  </a>.
</p>
      `,
      },
    ],
  },
  {
    name: "overview2",
    title: "Funding Brackets",
    elements: [
      {
        type: "html",
        html: `
<p>
  There are two funding brackets available, one for small initiatives under
  $2,500 and one for larger initiatives between $2,500 and $8000. Each
  initiative is eligible to receive two small grants, or one large grant per
  financial year (1 July – 30 June). There are limited funds for distribution
  each financial year and once exhausted, the fund will be closed until the
  following year.
</p>
<p>
  There are two funding rounds per year, one that opens on February 16 and
  another that opens on Matariki. The fund will be open for three weeks from its
  opening date and outcomes of the applications will be notified four weeks
  following. 
</p>
<p>
  On 16 February, a deed of sale was signed by tūpuna of Rangitāne o Wairau. The
  transaction related to the Crown’s purchase of iwi land in the Wairau
  district: for the sum of £100 (and the promise of a 20-square-mile reserve),
  as a result, Rangitāne relinquished their customary rights to an area
  stretching from the mouth of the Wairau River and inland.
</p>
      `,
      },
    ],
  },
  {
    name: "overview3",
    title: "Matariki",
    elements: [
      {
        type: "html",
        html: `
<p>
  The date for Matariki was chosen because it marks a time of new beginnings, a fitting moment to launch new ventures. It is also a time to reflect on the past so that we may move confidently into the future. Upcoming Matariki dates are:
  <ul>
    <li>2026 Friday 10 July</li>
    <li>2027 Friday 25 June</li>
    <li>2028 Friday 14 July</li>
    <li>2029 Friday 6 July</li>
    <li>2030 Friday 21 June</li>
  </ul>
</p>
      `,
      },
    ],
  },
  {
    name: "overview4",
    title: "This Fund will not cover",
    elements: [
      {
        type: "html",
        html: `
<p>
  <ul>
    <li>
      Initiatives that are eligible for other Rangitāne o Wairau funding, such
      as Pūtea Tautoko etc.
    </li>
    <li>Commercial or profit-based ventures</li>
    <li>The purchase of alcohol</li>
    <li>The purchase of merchandise</li>
    <li>Initiatives delivered outside of Aotearoa</li>
    <li>Reimbursement of costs</li>
  </ul>
</p>
      `,
      },
    ],
  },
  {
    name: "overview5",
    title: "Assessment Criteria",
    elements: [
      {
        type: "html",
        html: `
<p>
  <ul>
    <li>Alignment with strategic priorities and cultural outcomes</li>
    <li>Demonstrated need or opportunity</li>
    <li>Feasibility of the kaupapa</li>
    <li>Strength of planning and leadership</li>
  </ul>
</p>
      `,
      },
    ],
  },
  {
    name: "overview6",
    title: "Contracting and Payment",
    elements: [
      {
        type: "html",
        html: `
<p>
  Successful applicants will enter into a formal agreement with the Trust
  outlining:
  <ul>
    <li>Agreed outcomes</li>
    <li>Financial responsibilities</li>
    <li>Timeframes for delivery</li>
    <li>Reporting requirements</li>
    <li>Initial payment upon execution of the agreement</li>
    <li>Final payment upon receipt and acceptance of the final report</li>
  </ul>
</p>
      `,
      },
    ],
  },
  {
    name: "overview7",
    title: "How your information will be used",
    elements: [
      {
        type: "html",
        html: `
<p>
  If your application is successful, information about you and/or the title of
  your initiative and the amount of funding granted may be published in the
  Rangitāne o Wairau Annual Report and may also be used in promotional material.
</p>
<p>
  By submitting this application, you authorise Rangitāne o Wairau to disclose
  information to, or obtain information from, any individual or organisation as
  necessary for the purpose of assessing your application.
</p>
<p>
  Your personal information will be handled in accordance with the Privacy Act
  2020, which governs how personal information is collected, used, stored, and
  shared. We will not publish or share any commercial or confidential
  information without your written consent.
</p>
<p>
  When your information is no longer required, it will be securely archived or
  destroyed in line with our policies and processes.
</p>
<p>
  If you have any questions or concerns about the information we hold about you,
  please contact us at
  <a href="mailto:admin@rangitane.org.nz" target="_blank">
    admin@rangitane.org.nz
  </a>
</p>
      `,
      },
    ],
  },
];
